import React from 'react'
import PropTypes from 'prop-types'

import { QRCodeForm } from '../dataViews/QRCodeForm'

export const StaffPasscode = ({
  isLocalEnvironment,
  routeData,
  defaultData,
  modSchema = JSON.parse(routeData.apiEndPointSchema),
  envData,
}) => {
  const defaultUserData = JSON.parse(sessionStorage.getItem('auth'))
  const [openEditFormModal, setOpenEditFormModal] = React.useState(false)
  const [selectEditFormModal, setSelectEditFormModal] = React.useState(null)

  const openFormEdit = (data) => {
    setOpenEditFormModal(true)
    setSelectEditFormModal(data)
  }

  const isLayoutDark = sessionStorage.getItem('themeLayout')
    ? sessionStorage.getItem('themeLayout')
    : false
  return (
    <React.Fragment key={isLayoutDark}>
      <div className="trtui-col-12">
        <div
          className="trtui-page-title-box trtui-d-sm-flex trtui-align-items-center trtui-justify-content-between"
          style={{ display: 'flex' }}
        >
          <h4 className="trtui-mb-sm-0">{routeData.pageTitle}</h4>
        </div>
      </div>
      <QRCodeForm
        openEditFormModal={openEditFormModal}
        isLocalEnvironment={isLocalEnvironment}
        crud={modSchema.form?.crud}
        setOpenEditFormModal={setOpenEditFormModal}
        envData={envData}
        routeData={routeData}
        defaultData={defaultData}
        data={{ formData: [{ ...defaultUserData.state.session.user, displayName: '' }] }}
        modSchema={modSchema}
        selectEditFormModal={selectEditFormModal}
        openFormEdit={openFormEdit}
        isStaff={true}
      />
    </React.Fragment>
  )
}

StaffPasscode.propTypes = {
  isLocalEnvironment: PropTypes.string,
  routeData: PropTypes.object,
  envData: PropTypes.object,
  modSchema: PropTypes.object,
  defaultData: PropTypes.object,
}
